/** Canonical tenant configuration subdomains shared by the web and voice runtimes. */
export const ConfigSubdomain = {
  ACS: "acs",
  ADSS: "adss",
  APEX: "apex",
  AUTONOMY: "autonomy",
  AXIA: "axia",
  BALANCE_HEALTH: "balance-health",
  CONFLUENT_ALL_STAR: "confluent-all-star",
  CONVENIENT_MD: "convenientmd",
  COUG: "coug",
  CRESCENTCARE: "crescentcare",
  CVVC: "stridecare-cvvc",
  ENT_PARTNERS: "entpartners",
  ENT_PARTNERS_ENTS: "ents",
  ENT_PARTNERS_MENT: "ment",
  ENT_PARTNERS_SCI: "sci",
  ENT_PARTNERS_SUBOTO: "suboto",
  FCC: "fcc",
  HVC: "hvc",
  INSIGHT: "insight",
  MASS_ENT: "massent",
  MINDPATH: "mindpath",
  NIMBUS: "nimbus",
  NIRA: "nira",
  NVISION_EWEI_TORRANCE: "ewei-torrance",
  PACESETTER: "pacesetter",
  PA_CENTRAL_REGION: "pediatricassociates-central",
  PA_EAST_REGION: "pediatricassociates-east",
  PINNACLE: "pinnacle",
  PMG: "pmg",
  PPCP: "ppcp",
  QOROS_BC: "qoros",
  QOROS_CFCG: "qoros-cfcg",
  SIENT: "sient",
  SPORTORTHO: "sportortho",
  STRIDECARE: "stridecare",
  TEXAS_HEART_SOUTH_HEART: "south-heart",
  TPR: "tpr",
  TRICITY: "tco",
  UPPERLINE_FLORIDA: "upperline-fl",
  UPPERLINE_GEORGIA: "upperline-ga",
  UPPERLINE_INDIANA: "upperline-in",
  UPPERLINE_TENNESSEE: "upperline-tn",
  UPSTREAM_REHABILITATION: "upstream",
  US_UROLOGY_PARTNERS: "us-uro",
  USHV_CCOH: "ushv-ccoh",
  USHV_FORTWORTH: "ushv-fortworth",
  USHV_HEARTLAND: "ushv-heartland",
  USHV_HEARTPLACE: "ushv-heartplace",
  USHV_MCA: "ushv-mca",
  USHV_MKC: "ushv-mkc",
  USHV_ORION: "ushv-orion",
  USHV_PIMA: "ushv-pima",
  USRC: "usrc",
  USRC_CPS_AK: "usrc-cps-ak",
  USRC_CPS_CO: "usrc-cps-co",
  UVVC: "uvvc",
  VALERIE: "valerie",
  VALERIE_HEALTH_TRAINING: "training",
  VPS: "vps",
} as const;

export type ConfigSubdomain = (typeof ConfigSubdomain)[keyof typeof ConfigSubdomain];
